import { call, put, select, takeLatest } from 'redux-saga/effects'
import { PcrDocsService } from '../../../../services/pcrDocs.service'
import { getPcrIdSelector } from '../../../home/selectors'
import { IPcr } from '../../../pcr/store/pcr.types'
import { getServiceIdSelector } from '../../../user/selectors'
import { getChildbirthOBSelector } from '../selectors'
import { saveChildbirthOB } from '../store/childbirthOB.actions'
import { ChildbirthOBConstants } from '../store/childbirthOB.constants'
import { IChildbirthOBState } from '../store/childbirthOB.types'
import { performWithMutexHOG } from '../../../../services/mutexUtility.service'

export function* setSuccessfulAttempt() {
  const childbirthOBState: IChildbirthOBState = yield select(getChildbirthOBSelector)
  const { successfulAttempt } = childbirthOBState
  const serviceId: string = yield select(getServiceIdSelector)
  const pcrDocsService = new PcrDocsService(serviceId)
  const pcrID: string = yield select(getPcrIdSelector)
  if (pcrID) {
    const pcrDoc: IPcr = yield call([pcrDocsService, pcrDocsService.getPCR], pcrID)
    if (pcrDoc.patient?.childbirthOBStateList && pcrDoc.patient?.childbirthOBStateList.length) {
      const index = pcrDoc.patient?.childbirthOBStateList?.findIndex(
        (childbirthOB) => childbirthOB.key === childbirthOBState.key
      )
      if (index !== -1) {
        if (pcrDoc.patient.childbirthOBStateList[index].successfulAttempt !== successfulAttempt) {
          yield put(saveChildbirthOB())
        }
      }
    } else {
      yield put(saveChildbirthOB())
    }
  } else {
    // todo: add to audit log
  }
}

export function* setSuccessfulAttemptSaga() {
  yield takeLatest([ChildbirthOBConstants.SET_SUCCESSFUL_ATTEMPT], performWithMutexHOG, setSuccessfulAttempt)
}
